export default __webpack_public_path__ + "static/media/close.09fee80d.svg";